<template>
    <div>
        <app-layout-align
            :data-source="'tecpage.user.modules.' + moduleId + '.layout.align'"
            :options="getActiveModuleLayoutAlign"
            :data-default="{ type: 'first' }"
        ></app-layout-align>

        <app-layout-type
            :data-source="'tecpage.user.modules.' + moduleId + '.layout.type'"
            :options="getActiveModuleLayoutTypes"
            :data-default="{ type: 'first' }"
        ></app-layout-type>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import LayoutAlign from '@/components/fields/simple/LayoutAlign.vue';
import LayoutType from '@/components/fields/simple/LayoutType.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getActiveModuleLayoutTypes', 'getActiveModuleLayoutAlign'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R011'),
            help: this.$helpers.uiText('R012'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-layout-align': LayoutAlign,
        'app-layout-type': LayoutType
    }
};
</script>
